// extracted by mini-css-extract-plugin
export var productImage = "_kx-1";
export var viewLink = "_kx-2";
export var wishlistItem = "_kx-0";